import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SessionService } from '../../core/session.service';
import { I18nService } from '../../core/i18n.service';
import { ProfileCompletionService } from '../../core/profile-completion.service';
import { PageSection } from '../page-section/page-section';

@Component({ selector: 'app-home', standalone: true, imports: [RouterLink, PageSection], templateUrl: './home.html', styleUrl: './home.scss' })
export class Home {
  isCompletionStepsOpen = false;

  constructor(public session: SessionService, public i18n: I18nService, public profileCompletion: ProfileCompletionService) {}

  get readinessScore(): number { return this.profileCompletion.score(); }

  get readinessBarWidth(): number { return this.profileCompletion.barWidth(); }

  toggleCompletionSteps(): void { this.isCompletionStepsOpen = !this.isCompletionStepsOpen; }
}
